export default {
    methods: {
        clone: function(obj) {

            if (Array.isArray(obj)) {

                return obj.map(m => this.clone(m))
            }
            else if (obj instanceof File) {

                return new File([obj], obj.name)
            }
            else if (obj instanceof Date) {

                return new Date(obj.getTime())
            }
            else if (obj === Object(obj) && typeof obj !== 'function') {

                const newObj = {}

                Object.keys(obj).forEach(k => {

                    newObj[k] = this.clone(obj[k])
                })

                return newObj
            }

            return obj;
        },
    }
}